<template>
    <div class="condition-content">
        <compare-selector
            ref="selector"
            :value="currentValue"
            :valid="valid"
            :multiple="true"
            type="AGE"
            placeholder="请选择年龄段"
            @change="onChange"
        />
    </div>
</template>

<script>
import CompareSelector from './plugins/compare-selector';
import { selectValidator } from './validate';

export default {
  name: 'Age',

  components: {
    CompareSelector,
  },

  props: {
    optionInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    const currentValue = this.value || [];
    return {
      currentValue,
      valid: true,
    };
  },
  computed: {
    brief() {
      const selectText = this.$refs.selector.currentOptions
        .filter(obj => this.currentValue.indexOf(obj.value) > -1)
        .map(item => item.text)
        .join(',');
      return `${this.optionInfo.text}为${selectText}`;
    },
  },

  watch: {
    value(newValue) {
      this.currentValue = newValue || [];
    },
  },

  mounted() {
    this.onChange(this.currentValue);
  },

  methods: {
    validate() {
      this.valid = selectValidator(this.currentValue);
      return this.valid;
    },
    onChange(value) {
      this.valid = true;
      this.currentValue = value;
      const ruleData = this.handleShowVal(value);
      // 年龄段返回数据中 fieldConditionList
      const showVal = value;
      this.$emit('change', {
        ruleData,
        showVal,
        brief: this.brief,
        validation: selectValidator(value),
      });
    },

    handleShowVal(value) {
      const result = { relation: 'or', name: 'age' };
      const mapObj = [
        { value: 0, operation: '<', name: 'age', type: 'int' },
        {
          fieldConditionList: [
            { value: 0, operation: '>=', name: 'age', type: 'int' },
            { value: 18, operation: '<', name: 'age', type: 'int' },
          ],
          relation: 'and',
        },
        {
          fieldConditionList: [
            { value: 18, operation: '>=', name: 'age', type: 'int' },
            { value: 30, operation: '<', name: 'age', type: 'int' },
          ],
          relation: 'and',
        },
        {
          fieldConditionList: [
            { value: 30, operation: '>=', name: 'age', type: 'int' },
            { value: 50, operation: '<', name: 'age', type: 'int' },
          ],
          relation: 'and',
        },
        { value: 50, operation: '>=', name: 'age', type: 'int' },
      ];
      const ageList = mapObj.filter((_, index) => value.includes(index));
      result.fieldConditionList = ageList || [];
      return result;
    },
  },
};
</script>
